const ENV = process.env.REACT_APP_ENV || "dev";

const CONFIG = {
  dev: {
    baseURL: "https://api-dev.zabali.co/",
    razorpayKey: process.env.REACT_APP_RAZORPAY_KEY,
  },
  stage: {
    baseURL: "https://api-dev.zabali.co/",
    razorpayKey: process.env.REACT_APP_RAZORPAY_KEY,
  },
  prod: {
    baseURL: "https://api.zabali.co/",
    razorpayKey: process.env.REACT_APP_RAZORPAY_KEY,
  },
};

export default CONFIG[ENV];
